import { useTheme } from "@emotion/react";
import React, { useEffect, useRef, useState } from "react";
import MobileHeader from "../../../../layout/DriverLayout/Header";
import { Box, Typography } from "@mui/material";
import ArrowTickLeft from "../../../../../media/images/icons/arrow-tick-left.svg";
import profileImage from "../../../../media/images/profileImage.png";
import Header from "./Header";
import LastViews from "./LastViews";
import Courses from "./Courses";
import BottomTabbar from "../../../../layout/DriverLayout/BottomTabbar";

export default function CoursesPage() {
  const [hasScroll, setHasScroll] = useState(false);
  const divRef = useRef<HTMLDivElement>(null);

  const theme = useTheme();

  useEffect(() => {
    const handleScroll = () => {
      if (divRef.current && divRef.current.scrollTop > 5) {
        // Do something when scrolled more than 20 pixels
        setHasScroll(true);
      } else {
        setHasScroll(false);
      }
    };

    if (divRef.current) {
      divRef.current.addEventListener("scroll", handleScroll);
    }

    return () => {
      // Cleanup: remove the event listener when the component unmounts
      if (divRef.current) {
        divRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);
  return (
    <>
      <MobileHeader title={HeadTitle()} hasScroll={hasScroll} />
      <Box
        sx={{
          flex: 1,
          overflow: "auto",
          pb: 3,
        }}
      >
        <Header />
        <LastViews />
        <Courses />
      </Box>
      <BottomTabbar />
    </>
  );
}

function HeadTitle() {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Typography
        sx={{
          color: "secondary.main",
          fontWeight: 600,
        }}
      >
        کارن کلاب{" "}
      </Typography>
      <img src={ArrowTickLeft} alt="" />
      <Typography
        sx={{
          color: "secondary.main",

          fontSize: "12px",
          fontWeight: 600,
        }}
      >
        مشاهده آموزش{" "}
      </Typography>
    </Box>
  );
}
